import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import { GetAllButtonByRoleId } from '@/api/sys.menu';
import { GetOrg } from '@/api/sys.user';
import util from '@/libs/util.js';
export default {
  namespaced: true,
  state: {
    btnList: [],
    btnListObj: {},
    tableTools: false
  },
  mutations: {
    SET_BTN_LIST: function SET_BTN_LIST(state, value) {
      state.btnList = value;
    },
    SET_BTN_LIST_OBJ: function SET_BTN_LIST_OBJ(state, value) {
      state.btnListObj = value;
    },
    SET_TABLE_TOOLS: function SET_TABLE_TOOLS(state, value) {
      state.tableTools = value;
    }
  },
  actions: {
    getBtnList: function () {
      var _getBtnList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var commit, rootState, roleId, res, data, btnList, btnListObj;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit, rootState = _ref.rootState;
                // console.log('rootState',rootState);
                // return new Promise(async resolve => {
                roleId = rootState.d2admin.user.info.ROLE_ID || '';
                _context.next = 4;
                return GetAllButtonByRoleId(roleId);

              case 4:
                res = _context.sent;
                data = res.data || [];
                btnList = data.map(function (item) {
                  return item.Menu_Code;
                }); // const btnList = data.map(item => item)

                commit('SET_BTN_LIST', btnList);
                btnListObj = data.map(function (item) {
                  return item;
                });
                commit('SET_BTN_LIST_OBJ', btnListObj);
                return _context.abrupt("return", btnList);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getBtnList(_x) {
        return _getBtnList.apply(this, arguments);
      }

      return getBtnList;
    }(),
    getOrgInfo: function () {
      var _getOrgInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
        var commit, rootState, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref2.commit, rootState = _ref2.rootState;
                _context2.next = 3;
                return GetOrg();

              case 3:
                res = _context2.sent;
                console.log('获取org', res);

                if (res.code === 0) {
                  if (util.cookies.get('ORG_ID')) {
                    util.cookies.set('ORG_CODE', util.cookies.get('ORG_CODE'));
                    util.cookies.set('ORG_ID', util.cookies.get('ORG_ID'));
                  } else {
                    util.cookies.set('ORG_CODE', res.data[0].Id);
                    util.cookies.set('ORG_ID', res.data[0].Id);
                  }
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getOrgInfo(_x2) {
        return _getOrgInfo.apply(this, arguments);
      }

      return getOrgInfo;
    }()
  }
};